export default "__VITE_ASSET__CRGhjTYZ__"